import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import { Location } from "@/components/site/Location";
import { ContactForm } from "@/components/site/ContactForm";
import { Trust } from "@/components/site/Trust";

export default function ContactPage() {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Seo
                title="Kontakt | Ramljak Auto Detailing Centar Ljubuški"
                siteName="Ramljak Auto Detailing Centar"
                description="Kontaktirajte Ramljak Auto Detailing Centar — Ulica Hrvatskih kraljeva 35, Ljubuški. Telefon 063 640 050. Radno vrijeme i lokacija."
            />
            <div className="pt-20 md:pt-24">
                <Location />
            </div>
            <ContactForm />
            <Trust />
        </motion.main>
    );
}
